import { render, staticRenderFns } from "./CtaLayer.vue?vue&type=template&id=099a10d4&"
import script from "./CtaLayer.vue?vue&type=script&lang=ts&"
export * from "./CtaLayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports